import {
  FETCH_DATA_FROM_TARGET_FOR_GRAPHS,
  SET_TARGET_DEFINITION_DIRTY
} from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'

export function createTargetDefinitionWatcher (store) {
  return store.watch(() => store.getters.targetDefinition, newVal => {
    /**
     * For some reason, the watcher callback is called before the getter recomputes
     * dispatching the below before we want it to. The start date is empty in this situation
     * which causes the api response to fail. We check if start date is empty before
     * dispatching FETCH_DATA_FROM_TARGET_FOR_GRAPHS to fix the error.
     *
     * We also don't want to fetch target data for an activated target as we will have
     * the data to display in the current target object.
     *
     * We also need to make sure we have a currentTarget before fetching target data.
     */
    if (newVal.startDate !== '' && store.getters.currentTarget.id && !store.getters.isTargetActivated) {
      store.dispatch(FETCH_DATA_FROM_TARGET_FOR_GRAPHS)
      store.dispatch(SET_TARGET_DEFINITION_DIRTY, true)
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/views/workbench/AD/store/watchers.js